export enum QuestionnaireStatus {
  New = 0,
  Current = 1,
  Obsolete = 2
}

export const StateMobilityQuestionnaire = QuestionnaireStatus;

export interface QuestionnaireSectionInterface {
  sectionId: number;
  title: string;
  questions: QuestionnaireQuestionInterface[];
}

export interface QuestionnaireQuestionInterface {
  questionId: number;
  question: string;
  answerType: "text" | "radio" | "multichoice";
  answer?: string;
  answerChoices?: string[];
}

export interface QuestionnaireSubmissionInterface {
  sections: SubmissionSectionInterface[];
}

export interface SubmissionSectionInterface {
  sectionId: number;
  questions: SubmissionQuestionInterface[];
}

export interface QuestionnaireScore {
  score: number;
  maxPossibleScore: number;
  maturity?: "Low" | "Medium" | "High" | null;
}

export interface SubmissionQuestionInterface {
  questionId: number;
  answer?: string;
}

export class MobilityQuestionnaire {
  id: string | null;
  createdAt: Date | null;
  completedAt: Date | null;
  updatedAt: Date | null;
  state: QuestionnaireStatus;
  sections: QuestionnaireSectionInterface[];
  sharePointUpdatedForm: QuestionnaireSectionInterface[] | null;
  score: QuestionnaireScore | null;

  constructor(data: {
    id: string | null;
    createdAt?: Date | null;
    completedAt?: Date | null;
    updatedAt?: Date | null;
    state?: QuestionnaireStatus;
    sections: QuestionnaireSectionInterface[];
    sharePointUpdatedForm?: QuestionnaireSectionInterface[] | null;
    score?: QuestionnaireScore | null;
  }) {
    this.id = data.id ?? null;
    this.createdAt = data.createdAt ?? null;
    this.completedAt = data.completedAt ?? null;
    this.updatedAt = data.updatedAt ?? null;
    this.state = data.state ?? QuestionnaireStatus.New;
    this.sections = data.sections;
    this.sharePointUpdatedForm = data.sharePointUpdatedForm ?? null;
    this.score = data.score ?? null;
  }

  isEmpty(): boolean {
    return (
      this.sections.every(
        (section) =>
          !section.questions ||
          section.questions.every(
            (question) => !question.answer || question.answer.trim() === ""
          )
      )
    );
  }

  isCompleted(): boolean {
    return this.completedAt !== null && this.completedAt !== undefined;
  }

  isObsolete(): boolean {
    return this.state === QuestionnaireStatus.Obsolete;
  }

  getExpirationDate(): Date {
    const expirationDate = new Date(this.createdAt ?? new Date());
    expirationDate.setMonth(expirationDate.getMonth() + 12);
    return expirationDate;
  }

  getStateLabel(): string {
    const labels = {
      [QuestionnaireStatus.New]: "Nouveau",
      [QuestionnaireStatus.Current]: "Actuel",
      [QuestionnaireStatus.Obsolete]: "Obsolète"
    };
    return labels[this.state] || "Inconnu";
  }
}
